import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const ToolCallListRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #d0d7de;
  font-family:
    ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono",
    monospace;
`;

export const ToolCallDetails = styled.details`
  font-size: 12px;
  color: #1f2328;
  background: #fff;

  & + & {
    border-top: 1px solid #d0d7de;
  }
`;

export const ToolCallSummary = styled.summary`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 6px 10px;
  user-select: none;
  list-style: none;
  background: #f6f8fa;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;

  &::-webkit-details-marker {
    display: none;
  }

  &:hover {
    background: #eef1f4;
  }
`;

export const Chevron = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: #656d76;
  transition: transform 0.15s ease;

  details[open] > summary > & {
    transform: rotate(90deg);
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const StatusIcon = styled.span<{ status: "completed" | "running" }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 50%;
  font-size: 10px;
  line-height: 1;
  background: ${({ status }) =>
    status === "completed" ? "#dafbe1" : "transparent"};
  color: ${({ status }) => (status === "completed" ? "#1a7f37" : "#656d76")};
`;

export const ToolCallName = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ToolCallBody = styled.div`
  padding: 0 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SectionLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #656d76;
  padding: 8px 0 4px;
  border-bottom: 1px solid #eaecef;
  margin-bottom: 2px;
`;

export const CodeBlock = styled.pre`
  font-size: 11px;
  line-height: 1.5;
  background: #f6f8fa;
  border: 1px solid #eaecef;
  border-radius: 4px;
  padding: 8px 10px;
  max-height: 240px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  color: #1f2328;

  font-family:
    ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono",
    monospace;
`;

export const ResponseScroll = styled.div`
  max-height: 300px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DocChunkDetails = styled.details`
  border: 1px solid #eaecef;
  border-radius: 4px;
  overflow: hidden;

  &[open] > summary {
    border-bottom: 1px solid #eaecef;
  }
`;

export const DocChunkSummary = styled.summary`
  font-size: 11px;
  font-weight: 600;
  color: #1f2328;
  cursor: pointer;
  user-select: none;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 4px 8px;
  background: #f6f8fa;

  &::-webkit-details-marker {
    display: none;
  }

  &:hover {
    background: #eef1f4;
  }
`;

export const DocChunkContent = styled.pre`
  font-size: 11px;
  line-height: 1.5;
  padding: 8px 10px;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 200px;
  overflow: auto;
  color: #1f2328;

  font-family:
    ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono",
    monospace;
`;

export const ToolCallSpinner = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1.5px solid #d0d7de;
  border-top-color: #656d76;
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;
